export const KONFIR_VERIFICATION_LINK_CREATE_ERROR =
  "Konfir system is currently unavailable. Please click the link provided and complete the other sections on this form. We will contact you once the Konfir system is back online";
